import { Provider, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import { useEffect } from 'react';

import { Layout } from '@poliedro/tamentai';

import Header from './components/Header';
import NavBar from './components/NavBar';
import { useBootstrapFeatures } from './hooks/useBootstrapFeatures';
import { useToken } from './hooks/useToken';
import ErrorPage from './pages/ErrorPage';
import InitialPage from './pages/InitialPage';
import AppRoutes from './routes';
import { getMqttClient } from './services/mqtt/index';
import { persistor, RootState, store } from './store';

function AppContent() {
  const profile = useSelector((state: RootState) => state.profile.profileData);
  const location = useLocation();
  const isErrorPage = location.pathname === '/error';

  useToken({ enabled: !isErrorPage });
  useBootstrapFeatures();

  useEffect(() => {
    getMqttClient();
  }, []);

  if (isErrorPage) {
    return <ErrorPage />;
  }

  if (!profile) {
    return <InitialPage />;
  }

  return (
    <Layout.Root logo={''} primaryColor="#005FFB">
      <Layout.Navbar>
        <Layout.Close />
        <Layout.Profile>
          <Layout.Text text={profile?.nomeEscola ?? ' '} variant="title" />
          <Layout.Text text={profile?.enderecoEscola ?? ''} />
          <Layout.Text text={profile?.segmentos?.join(' - ') ?? ''} />
        </Layout.Profile>
        <NavBar />
      </Layout.Navbar>
      <Layout.Content>
        <Header
          name={profile?.nome ?? ''}
          userProfile={profile?.perfil.nome ?? ''}
        />
        <Layout.Body>
          <AppRoutes />
        </Layout.Body>
      </Layout.Content>
    </Layout.Root>
  );
}

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppContent />
      </PersistGate>
    </Provider>
  );
}

export default App;
